import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ROTUES } from "../../utils/global";
import EditIcon from "../../assets/Icons/EditIcon";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { deleteTouchAction } from "../../store/actions/projectAction";

function Touches() {
  const touches = useSelector((state) => state.project?.touches);
  const [deleteConfirmation, setDeleteConfirmation] = useState({ show: false, touchId: null, projectId: null });

  const dispatch = useDispatch();

  const showDeleteConfirmation = (touchId, projectId) => {
    setDeleteConfirmation({ show: true, touchId, projectId });
  };

  const handleDelete = () => {
    if (deleteConfirmation.touchId && deleteConfirmation.projectId) {
      dispatch(
        deleteTouchAction({
          id: deleteConfirmation.touchId,
          projectId: deleteConfirmation.projectId,
        })
      );
      setDeleteConfirmation({ show: false, touchId: null, projectId: null });
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmation({ show: false, touchId: null, projectId: null });
  };

  // Helper function to check if content is empty or missing
  const isContentMissingOrEmpty = (touch) => {
    return !touch.content || touch.content === "" || touch.content === "{}";
  };

  if (!touches) {
    return <div>Sections Not Found</div>;
  }

  return (
    <>
      {/* Delete Confirmation Modal */}
      {deleteConfirmation.show && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={cancelDelete}></div>
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">Confirm Delete</h3>
            <p className="mb-6">Are you sure you want to delete this touch? This action cannot be undone.</p>
            <div className="flex justify-end space-x-3">
              <button 
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                onClick={cancelDelete}
              >
                Cancel
              </button>
              <button 
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="px-4 py-4 border-b text-left">Section Name</th>
            <th className="px-4 py-4 border-b text-left">Room Name</th>
            <th className="px-4 py-4 border-b text-left">Touch Name</th>
            <th className="px-4 py-4 border-b text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {touches.map((touch, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="px-4 py-4 border-b">{touch?.section.name}</td>
              <td className="px-4 py-4 border-b">{touch?.room?.name}</td>
              <td className="px-4 py-4 border-b">
                <div className="flex items-center">
                  {touch?.name}
                  {isContentMissingOrEmpty(touch) && (
                    <div 
                      className="ml-2 w-3 h-3 rounded-full bg-green-500" 
                      title="Content is missing or empty"
                    ></div>
                  )}
                </div>
              </td>
              <td className="px-4 py-4 border-b flex space-x-2">
                <Link
                  to={`${ROTUES.editTouch}/${touch._id}`}
                  className="text-green-500 hover:text-green-700"
                >
                  <EditIcon />
                </Link>
                <button
                  className="text-red-500 hover:text-red-700"
                  onClick={() => showDeleteConfirmation(touch?._id, touch?.project?._id)}
                >
                  <DeleteIcon />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default Touches;
